import { ColumnDef } from '@tanstack/react-table';
import {
  DownloadedCheckmark,
  SortableHeader,
  TruncatedCell,
} from '@/components';
import { formatTableDate } from '../../utils/formatTableDate';
import {
  canTrackOriginalRecordDownload,
  getOriginalRecordSourceTypeLabel,
} from '@/feature/patients/types';
import { OriginalRecord } from '../types';
import { PatientDocumentViewButton } from '../../components';
import { DocumentSource, DocumentType } from '../../viewer';
import { DASH } from '../../utils/displayValues';

export const createOriginalRecordsColumns = (): ColumnDef<OriginalRecord>[] => [
  {
    accessorKey: 'name',
    header: 'Document',
    cell: ({ row }) =>
      row.original.name === null ? (
        DASH
      ) : row.original.name ? (
        <TruncatedCell text={row.original.name} />
      ) : (
        'No data available'
      ),
  },
  {
    id: 'dateUploaded',
    accessorFn: (row) => row.dateUploaded,
    enableSorting: true,
    header: ({ column }) => (
      <SortableHeader column={column}>Date Uploaded</SortableHeader>
    ),
    cell: ({ row }) => formatTableDate(row.original.dateUploaded),
  },
  {
    accessorKey: 'sourceType',
    enableSorting: true,
    header: ({ column }) => (
      <SortableHeader column={column}>Source Type</SortableHeader>
    ),
    cell: ({ row }) =>
      row.original.sourceType
        ? getOriginalRecordSourceTypeLabel(row.original.sourceType)
        : DASH,
  },
  {
    id: 'actions',
    enableSorting: false,
    header: '',
    cell: ({ row }) => {
      const showDownloadedCheckmark =
        row.original.markedDownloaded &&
        !!row.original.sourceType &&
        canTrackOriginalRecordDownload(row.original.sourceType);

      return (
        <div className="flex items-center justify-end gap-8">
          {showDownloadedCheckmark ? <DownloadedCheckmark /> : null}
          <PatientDocumentViewButton
            disabled={!row.original.sourceType}
            documentKey={{
              source: DocumentSource.MEDICAL_RECORDS,
              type: DocumentType.ORIGINAL_RECORDS,
              originalRecordId: row.original.id,
              sourceType: row.original.sourceType,
              name: row.original.name === null ? DASH : row.original.name,
            }}
          />
        </div>
      );
    },
  },
];
